import { Crown, Star, Flame, Shield, Zap, Trophy, Heart, Sparkles, Skull, Award, Gem, Rocket } from "lucide-react";

// Curated icon set for shop subtitles — picked from lucide-react (already a
// dependency) rather than free-text emoji, so every subtitle renders
// consistently regardless of platform/font emoji support.
export const SUBTITLE_ICONS = {
  crown: Crown,
  star: Star,
  flame: Flame,
  shield: Shield,
  zap: Zap,
  trophy: Trophy,
  heart: Heart,
  sparkles: Sparkles,
  skull: Skull,
  award: Award,
  gem: Gem,
  rocket: Rocket,
};

export const SUBTITLE_ICON_KEYS = Object.keys(SUBTITLE_ICONS);
